import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { endOfDay, format, startOfDay, subDays } from 'date-fns'
import { useState } from 'react'
import { DateRange } from 'react-day-picker'

import { supportRequestService } from '@/app/services/supportRequestService'

export const SUPPORT_OVERVIEW_STATS_QUERY_KEY = 'supportOverviewStats'

const DEFAULT_DAYS = 7
const MAX_DAYS = 90

export const defaultStatisticsRange = (): DateRange => ({
  from: startOfDay(subDays(new Date(), DEFAULT_DAYS - 1)),
  to: endOfDay(new Date()),
})

const toParam = (date?: Date) => (date ? format(date, 'yyyy-MM-dd') : undefined)

export const useSupportStatistics = () => {
  const [range, setRange] = useState<DateRange>(defaultStatisticsRange)
  const [members, setMembers] = useState<string[]>([])

  const from = toParam(range.from)
  const to = toParam(range.to ?? range.from)
  const params = { from, to, members }

  const query = useQuery({
    queryKey: [SUPPORT_OVERVIEW_STATS_QUERY_KEY, params],
    queryFn: () => supportRequestService.getSupportOverviewStats(params),
    staleTime: 60_000,
    enabled: !!from,
    placeholderData: keepPreviousData,
  })

  const changeRange = (next: DateRange | undefined) =>
    setRange(next?.from ? next : defaultStatisticsRange())

  const toggleMember = (id: string) =>
    setMembers((current) =>
      current.includes(id)
        ? current.filter((member) => member !== id)
        : [...current, id],
    )

  return {
    ...query,
    range,
    changeRange,
    members,
    toggleMember,
    clearMembers: () => setMembers([]),
    maxDays: MAX_DAYS,
  }
}
